<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator=">">
      <el-breadcrumb-item>Billing Overview</el-breadcrumb-item>
      <el-breadcrumb-item>Trial Subscription Info</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
    <h2 style="text-align: left;"> Overview of Subscription Trials </h2>
    <div class="container">
      请选择时间区间 <span style="width: 30px;"> </span><date-range-picker @date-change="handleDateChange" /> <span
        style="width: 30px;"> </span>
      </div>
    <el-divider></el-divider>
    <div class="grid">
      <div class="chart" id="chart1">数据等待中</div>
      <div class="chart" id="chart2">数据等待中</div>
      <div class="chart" id="chart3">数据等待中</div>
      <div class="chart" id="chart4">数据等待中</div>
    </div>
    <el-divider></el-divider>
    <h3 style="text-align: left;">详细数据       <el-button type="primary" @click="exportCsv"   style="  margin-left: 75%; " >下载 CSV</el-button></h3>
    <el-table :data="tableData" stripe style="width: 100%" :default-sort="{ prop: 'date', order: 'descending' }">

      <el-table-column prop="date" label="日期" width="150" sortable>
      </el-table-column>


      <el-table-column prop="newTrial" label="新增试用">
      </el-table-column>

      <el-table-column prop="endTrial" label="今日到期"> </el-table-column>

      <el-table-column prop="convertTrial" label="今日转化"> </el-table-column>
      <el-table-column prop="lostTrial" label="转化失败"> </el-table-column>
      <el-table-column prop="activeTrial" label="试用中"> </el-table-column>

      <el-table-column prop="retryingTrial" label="尝试扣款中"> </el-table-column>

      <el-table-column prop="endRoll" label="回滚30天到期"> </el-table-column>
      <el-table-column prop="convertRoll" label="回滚30天成功"> </el-table-column>
      <el-table-column prop="conversionRate" label="试用转化率"> </el-table-column>
      <el-table-column prop="lostTrialList" label="转化失败清单,点击直接跳转Stripe" width="510">
        <template slot-scope="scope">
          <span v-for="(item, index) in scope.row.lostTrialList.split(',')" :key="index">
            <a :href="`https://dashboard.stripe.com/subscriptions/${item.trim()}`" target="_blank">
              {{ item.trim() }}
            </a>
            <span v-if="index < scope.row.lostTrialList.split(',').length - 1">, </span>
          </span>
        </template>
      </el-table-column>



    </el-table>


  </div>
</template>

<script>

import dateRangePicker from './dateRangePicker.vue';
import { exportToCsv } from '@/utils/exportToCsv';
export default {
  components: {
    dateRangePicker
  },

  data() {
    return {
      tableData: [],
      dateRange: ''
    }
  },
  // 新增watch 观察参数变化,按照dateRange变化,重新getData
  watch: {
    dateRange() {
      this.getData(this.dateRange);
    }
  },

  // 新建methods 区域, 专门定义各个方法和参数的地方
  methods: {
    async getData(dateRange) {

      this.tableData = []

      let res = await this.$http.get("/da/get_subs_trial/" + dateRange)
      this.tableData = res.data
      this.initCharts();
    },

    handleDateChange(date) {
      this.dateRange = date;
      console.log('Selected date range:', this.dateRange);
    },

    exportCsv() {
      let fileName = "Subscription Trial Conversion Rate" + "_" + this.dateRange
      exportToCsv(this.tableData, fileName)
    },

    getRateColor(percent) {
      const value = parseFloat(percent) / 100
      if (value > 0.85) {
        return 'green'; // 数量小于10，设置颜色为绿色
      } else if (value >= 0.8 && value < 0.85) {
        return 'orange'; // 数量在10到20之间，设置颜色为橙色
      } else {
        return 'red'; // 数量大于等于20，设置颜色为红色
      }
    },
    initCharts() {

      this.createLineChart('chart1', 'New Trials', 'newTrial');
      this.createRateChart('chart2', 'Conversion Rate', 'conversionRate');//这个是另外的应为要转一下格式
      this.createLineChart('chart3', 'Active Trials', 'activeTrial');
      this.createLineChart('chart4', 'Converted Trials', 'convertTrial');
    },
    createLineChart(elementId, title, dataKey) {
      const chart = this.$echarts.init(document.getElementById(elementId));
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          },
          formatter: function (params) {
        const date = params[0].axisValue;
        const value = params[0].value;
        return `Date: ${date}<br/>${title}: ${value}`; // 显示日期和转换率
      },
        },
        title: {
          text: title,
        },
        xAxis: {
          type: 'category',
          data: this.tableData.map(item => item.date),
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            data: this.tableData.map(item => item[dataKey]),
            type: 'line',
            smooth: false,
            showSymbol: false, // 去掉标记点
          },
        ],
      };
      chart.setOption(option);
    },
    
    createRateChart(elementId) {
  const chart = this.$echarts.init(document.getElementById(elementId));
  const option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#6a7985'
        }
      },

      formatter: function (params) {
        const date = params[0].axisValue;
        const value = params[0].value;
        return `Date: ${date}<br/>Conversion Rate: ${value}%`; // 显示日期和转换率
      },
    },
    title: {
      text: 'Conversion Rate',
    },
    xAxis: {
      type: 'category',
      data: this.tableData.map(item => item.date),
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        formatter: '{value} %' // 显示百分比符号
      }
    },
    series: [
      {
        data: this.tableData.map(item => 
          parseFloat(item.conversionRate.replace('%', '')) // 将字符串转换为浮点数
        ),
        type: 'line',
        smooth: true,
        showSymbol: false, // 去掉标记点
      },
    ],
  };
  chart.setOption(option);
},


  },

  mounted: function () {



    //this.getData(this.dateRange)
    //console.log("trial_conversion bike_type ="  + bike_type+  "=" + filter+" 挂载完毕")
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  display: flex;
  justify-content: flex-end;
}

.device-number-link a {
  color: blue;
  /* 鼠标悬停时变为蓝色 */
  text-decoration: none;
  /* 移除下划线 */
}

.device-number-link a:hover {
  color: #ffaa00;
  /* 点击时变为海思蓝色 */
}

.device-number-link a:active {
  color: inherit;
  /* 正常状态下使用继承的颜色，即没有特别的颜色 */

}

.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 10px;
  width: 95%;

}

.chart {
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 5px;
  height: 280px;
}
</style>